import clsx from 'clsx';
import styles from './Card.module.css';

/**
 * Tank Redesign Card atom — bordered surface panel.
 *
 * Source: ~/Downloads/tank-redesign/tokens.jsx → `Card` function.
 * Default surface is `--rd-color-panel`. `surface="hi"` raises to panelHi
 * (use for hover/active or stacked content); `surface="lo"` recesses
 * (use for input fields).
 *
 * Lives in shared/components/redesign/ during migration to avoid colliding
 * with the legacy Card in shared/components/ui/Card. At M6 cleanup the
 * legacy Card is replaced by this one.
 *
 * @param {Object} props
 * @param {'default'|'hi'|'lo'} [props.surface='default']
 * @param {boolean} [props.padded=true] - apply default 16px padding
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children
 */
export default function Card({
  surface = 'default',
  padded = true,
  className,
  children,
  ...rest
}) {
  return (
    <div
      className={clsx(
        styles.card,
        styles[`surface-${surface}`],
        padded && styles.padded,
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
